import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { http, settings } from '../../utils/config';

const initialState = {
    categoryRules: null,
    isLoad: false,
    idwarehouse: null,
    isLoadWareHouse: false,
    /** Mã kho nhập tay khi API danh sách kho TikTok trả rỗng (404/empty). */
    manualWarehouseId: "",
    /** warehouse_id đang chọn từ dropdown (khi có warehouse_list). */
    selectedWarehouseId: "",
}
export const getCateGoryRulesTikTok = createAsyncThunk(
    'TikTok/getCateGoryRulesTikTok',
    async (id) => {
        const shopCipher = settings.getCookie("shop_cipherTikTok");
        const response = await http.get(
            `/get-category-rule-tiktok?shop_cipher=${shopCipher}&category_id=${id}&category_version=v2`
        );
        // TikTok returns data.size_chart, data.cod (no category_rules array)
        const raw = response.data?.data?.data;
        return raw && typeof raw === "object" ? raw : null;
    }
);
export const getWareHouseId = createAsyncThunk(
    'TikTok/getWareHouseId',
    async () => {
        const shopCipher = settings.getCookie("shop_cipherTikTok");
        const response = await http.get(
            `/product-stock-tiktok?shop_cipher=${shopCipher}`
        );
        return response.data.data.data;
    }
);
const getCateGoryRules = createSlice({
    name: "getCateGoryRules",
    initialState,
    reducers: {
        setManualWarehouseId: (state, action) => {
            state.manualWarehouseId = action.payload ?? "";
        },
        setSelectedWarehouseId: (state, action) => {
            state.selectedWarehouseId = action.payload ?? "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCateGoryRulesTikTok.pending, (state) => {
                state.isLoad = true;
            })
            .addCase(getCateGoryRulesTikTok.fulfilled, (state, action) => {
                state.categoryRules = action.payload;
                state.isLoad = false;
            })
            .addCase(getCateGoryRulesTikTok.rejected, (state) => {
                state.isLoad = false;
                state.categoryRules = null;
            })
            //
            .addCase(getWareHouseId.pending, (state) => {
                state.isLoadWareHouse = true;
            })
            .addCase(getWareHouseId.fulfilled, (state, action) => {
                state.idwarehouse = action.payload
                state.isLoadWareHouse = false;
            })
            .addCase(getWareHouseId.rejected, (state, action) => {
                state.isLoadWareHouse = false;
            })



    },
});

export const { setManualWarehouseId, setSelectedWarehouseId } = getCateGoryRules.actions;
export default getCateGoryRules.reducer;